module.exports = __webpack_public_path__ + "static/media/question.114912a9.PNG";